// Temporary hardcoded MLA covered-borrower question for LNDG-1483, gated by
// the `mla_question` entry of LENDING_ASK_ADDITIONAL_FIELDS. Replaced by the
// configurable lending questions system in the next release; the metadata key
// and option values match that system's `mla_status` semantic key so Alloy
// journey configs survive the upgrade unchanged.

import type { MlaStatusEnum } from "@lending/types";

interface AdditionalField {
  name: string;
  value: boolean;
}

interface MlaOption {
  value: MlaStatusEnum;
  isCoveredBorrower: boolean;
}

const MLA_METADATA_KEY = "mla_status";

// Applicant-facing labels live in the ApplicationQuestions component so the
// Fluent ids stay literal at the getString call sites.
const MLA_OPTIONS: MlaOption[] = [
  { value: "active_duty", isCoveredBorrower: true },
  { value: "active_duty_dependent", isCoveredBorrower: true },
  { value: "none", isCoveredBorrower: false },
];

function isMlaQuestionEnabled(fields?: AdditionalField[] | null): boolean {
  return fields?.some((field) => field.name === "mla_question" && field.value) ?? false;
}

function isCoveredBorrowerValue(value: string | undefined): boolean {
  return MLA_OPTIONS.some((option) => option.value === value && option.isCoveredBorrower);
}

/**
 * Merge the stashed MLA answer into the metadata sent at application
 * creation.
 */
function withMlaStatusMetadata(
  applicationMetadata: Record<string, string> | undefined,
  mlaStatus: string | undefined
): Record<string, string> | undefined {
  if (!mlaStatus) return applicationMetadata;
  return { ...(applicationMetadata ?? {}), [MLA_METADATA_KEY]: mlaStatus };
}

export {
  MLA_METADATA_KEY,
  MLA_OPTIONS,
  isCoveredBorrowerValue,
  isMlaQuestionEnabled,
  withMlaStatusMetadata,
};
